document.addEventListener('DOMContentLoaded', function()
{
    if (!document.querySelector('#product'))
    {
        return;
    }

    // Elements
    const imageSlider360Trigger = document.querySelector('.js-360-trigger');
    const imageSlider360Container = document.querySelector('.product-image-360-container');
    const imageSliderVideoContainers = document.querySelectorAll('.js-view-video');

    // Selectors
    const imageSliderSelector =  '#product-images .js-product-images__slider';
    const thumbnailNavigationSelector =  '#product-images .js-product-images__navigation';
    const thumbnailNavigationItemSelector =  thumbnailNavigationSelector + ' .tns-item';

    // Events
    const indexChangedEvent = new Event(orion.constants.EventProductImageIndexChanged);
    const load360Event = new Event(orion.constants.EventProductImageLoad360Image);

    // Sliders
    const imageSlider = tns({
        container: imageSliderSelector,
        items: 1,
        nav: false,
        loop: false,
        preventScrollOnTouch: 'auto',
        onInit: () =>
        {
            document.querySelector(imageSliderSelector).classList.remove('hidden');
        }
    });

    const thumbnailNavigation = tns({
        container: thumbnailNavigationSelector,
        items: orion.getShopViewCode() === 'mobile' ? 4 : 6,
        slideBy: 4,
        nav: false,
        loop: false,
        preventScrollOnTouch: 'auto',
        onInit: () =>
        {
            document.querySelector(thumbnailNavigationSelector).classList.remove('hidden');
            document.querySelector(thumbnailNavigationItemSelector).classList.add('tns-slide-selected');
        }
    });

    // Events
    const navigationArray = [...thumbnailNavigation.getInfo().slideItems];

    navigationArray.forEach((slide, index) =>
    {
        slide.addEventListener('click', () =>
        {
            imageSlider.goTo(index);
            thumbnailNavigation.goTo(index);
        });
    });

    imageSlider.events.on('indexChanged', info =>
    {
        navigationArray.forEach((item, index) =>
        {
            if (index === info.index)
            {
                item.classList.add('tns-slide-selected');
            }
            else
            {
                item.classList.remove('tns-slide-selected');
            }
        });

        imageSliderVideoContainers.forEach(videoContainer =>
        {
            if (!videoContainer.classList.contains('tns-slide-active'))
            {
                videoContainer.querySelector('video').pause();
            }
        });

        thumbnailNavigation.goTo(info.index);

        document.dispatchEvent(indexChangedEvent);
    });

    if (orion.getShopViewCode() === 'mobile' && imageSlider360Trigger)
    {
        imageSlider360Trigger.addEventListener('click', () =>
        {
            imageSlider360Container.classList.remove('hidden');

            imageSlider360Container.dispatchEvent(load360Event);
        });
    }
});
